// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__6eJNN","requiredAsterisk":"Info_requiredAsterisk__NaAdz"};